import { FC } from "react";
import { Handle, Position } from "react-flow-renderer";
import { Typography } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { EMPTY_OUTGOING_MESSAGE_PLACEHOLDER } from "src/config/constants"
import { useStore, connect } from 'src/store/connect';

interface FinishBlockProps {
  data: NodeData;
}

const FinishBlock: FC<FinishBlockProps> = ({ data }) => {
  const classes = useStyles();
  const state = useStore();

  return (
    <div className={classes.root}>
      <Handle
        type="target"
        position={Position.Left}
        onConnect={(params) => {}}
        isConnectable={false}
      />
      <div className={`${(!data.highlighted && state.simulationRunning)? classes.opacity : ''}`}>
        {
          data.outgoingMessage && data.outgoingMessage !== ''? <Typography className={classes.label}>{data.outgoingMessage}</Typography>
          : <Typography className={classes.labelEmpty}>{EMPTY_OUTGOING_MESSAGE_PLACEHOLDER}</Typography>
        }
        <div className={classes.type}>Finalizar</div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={false}
      />
    </div>
  );
};

export default connect(FinishBlock);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "186px",
    padding: "21px 20px 19px 21px",
    borderRadius: "8px",
    boxShadow: "0 2px 24px 0 rgba(0, 0, 0, 0.08)",
    border: "solid 1px #f95a59",
    backgroundColor: "#ffffff",
  },
  label: {
    margin: "0 0 67px",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
    color: "#1d262c",
    overflowWrap: "break-word",
  },
  opacity: {
    opacity: 0.36,
    filter: "grayscale(1)",
  },
  labelEmpty: {
    fontSize: "14px",
    fontWeight: 400,
    color: "#445561"
  },
  type: {
    width: "105px",
    height: "20px",
    margin: "67px 40px 0 0",
    fontFamily: "Poppins",
    fontSize: "14px",
    color: "#f95a59",
    fontWeight: 600,
  },
}));
